import { fetchClients } from '../../api/clients';
import { fetchVisits } from '../../api/visits';
import { fetchTecnicos } from '../../api/users';
import { ApiError } from '../../api/client';
import { clients, visits, tecnicos, isAdmin, dataLoading } from '../state';
import { logout } from './auth.actions';

export async function loadData() {
  const firstLoad = clients.value.length === 0 && visits.value.length === 0;
  if (firstLoad) dataLoading.value = true;
  try {
    clients.value = await fetchClients();
    visits.value = await fetchVisits();
    if (isAdmin.value) {
      try {
        tecnicos.value = await fetchTecnicos();
      } catch {
        tecnicos.value = [];
      }
    }
  } catch (e) {
    if (e instanceof ApiError && e.status === 401) logout();
  } finally {
    if (firstLoad) dataLoading.value = false;
  }
}
